import { render, staticRenderFns } from "./PlannerLevelAssign.vue?vue&type=template&id=965736f4"
import script from "./PlannerLevelAssign.vue?vue&type=script&lang=js"
export * from "./PlannerLevelAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports